import React, { useContext, useEffect, useState } from "react";
import {
  PersonStanding,
  Stethoscope,
  UserRound,
  Smartphone,
  Camera,
  Activity,
} from "lucide-react";
import { GlobalContext } from "../Context/GlobalContext";
import { useLocation } from "react-router-dom";
import storage from "../Assets/js/Global";
import { Alert } from "react-bootstrap";
import { images } from "../Assets/images";
import HeightModal from "../modals/HeightModal";
import WeightModal from "../modals/WeightModal";
import WaistModal from "../modals/WaistModal";

const GuestScan = () => {
  const location = useLocation();
  const guestData = location.state?.guestData;

  const {
    translatedLabels,
    setMsgLoader,
    saveGuestUser,
    getGuestUserDetails,
    getUserScanLimit,
    scanLimit,
    is4Life,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const screenLabels = translatedLabels?.common;
  const [diabetesYesNo, setDiabetesYesNo] = useState("");
  const [diabetesType, setDiabetesType] = useState("");
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    age: "",
    weight: 150,
    weightUnit: "lbs",
    height: 5.6,
    heightUnit: "feet",
    waistUnit: "inch",
    waist_circumference: 32,
    smoking: "",
    race: "",
    hypertension: "",
    diabetes: "",
    cameraMode: "front",
  });
  const [showWeightModal, setWeightModal] = useState(false);
  const [showHeightModal, setShowHeightModal] = useState(false);
  const [showWaistModal, setShowWaistModal] = useState(false);
  const [servingData, setServingData] = useState({
    fruits: "",
    vegetables: "",
    grains: "",
    sugaryFoods: "",
    redMeat: "",
    fish: "",
    activity: "",
  });

  useEffect(() => {
    const fetchDetails = async () => {
      if (guestData?.guest_user_key) {
        // setMsgLoader(true);
        const details = await getGuestUserDetails(guestData.guest_user_key);
        if (details) {
          console.log(details, "details");

          const extracted = extractProfileData(details);
          setProfileData(extracted);

          if (extracted.diabetes === "No") {
            setDiabetesYesNo("2");
          } else if (extracted.diabetes) {
            setDiabetesYesNo("1");
            setDiabetesType(extracted.diabetes);
          }
        }
        setMsgLoader(false);
      }
    };
    fetchDetails();
    getUserScanLimit();
  }, [guestData, getGuestUserDetails, setMsgLoader]);

  useEffect(() => {
    storage.set("scanGuest", true);
  }, []);

  const [formSubmitted, setFormSubmitted] = useState(false);

  const extractProfileData = (user) => ({
    firstName: user?.first_name || "",
    lastName: user?.last_name || "",
    dob: user?.dob || "",
    age: user?.age || "",
    weight: user?.weight || 150,
    weightUnit: user?.weight_unit || "lbs",
    heightUnit: user?.height_unit || "feet",
    waistUnit: user?.waist_unit || "cm",
    height: user?.height || 5.6,
    gender: user?.gender || "",
    race: user?.race || "",
    waist_circumference: user?.waist_circumference || 80,
    diabetes: user?.diabetes === "No" ? "No" : user?.diabetes || "",
    smoking: user?.smoking || "",
    hypertension: user?.hypertension || "",
    wellnessCategory: user?.wellness_category || [],
    cameraMode: user?.cameraMode || "front",
  });

  const handleInputChange = (field, value) => {
    setProfileData((prev) => ({ ...prev, [field]: value }));
  };

  const handleServingChange = (key, value) => {
    setServingData((prev) => ({ ...prev, [key]: value }));
  };

  const servingOptions = ["0", "1", "2", "3", "4", "5+"];

  const nutritionQuestions = [
    {
      key: "fruits",
      icon: images.fruit,
      label:
        screenLabels?.fruits?.label_value ||
        "How many servings of fruit do you typically eat each day? (1 serving = ½ cup)",
    },
    {
      key: "vegetables",
      icon: images.vegetable,
      label:
        screenLabels?.vegetables?.label_value ||
        "How many servings of vegetables do you typically eat each day? (1 cup raw or ½ cup cooked)",
    },
    {
      key: "grains",
      icon: images.wholeGrain,
      label:
        screenLabels?.grains?.label_value ||
        "How many servings of whole grains do you typically eat each day? (Examples: ½ cup cooked rice or oatmeal, 1 slice whole wheat bread, or 1 cup whole grain cereal)",
    },
    {
      key: "sugaryFoods",
      icon: images.sugar,
      label:
        screenLabels?.sugaryFoods?.label_value ||
        "How many servings of sugary foods do you typically eat each day? (e.g., cookie, doughnut, cake)",
    },
    {
      key: "redMeat",
      icon: images.redMeat,
      label:
        screenLabels?.redMeat?.label_value ||
        "How many servings of red meat do you typically eat each week? (~3 oz, about the size of your palm)",
    },
    {
      key: "fish",
      icon: images.fish,
      label:
        screenLabels?.fish?.label_value ||
        "How many servings of fish do you typically eat each week? (~3 oz, about the size of your palm)",
    },
  ];

  const RenderLabel = ({
    label,
    fieldKey,
    required,
    formData,
    formSubmitted,
  }) => {
    const isFieldInvalid =
      required && formSubmitted && !formData?.[fieldKey]?.toString().trim();
    return (
      <label className="form-label">
        {label} {isFieldInvalid && <span className="text-danger">*</span>}{" "}
      </label>
    );
  };

  const renderLabelWithValidation = (fieldKey, label, required = false) => (
    <RenderLabel
      label={label}
      fieldKey={fieldKey}
      required={required}
      formData={profileData}
      formSubmitted={formSubmitted}
    />
  );

  const validateForm = () => {
    const requiredFields = [
      "firstName",
      "lastName",
      "age",
      "weight",
      "height",
      "waist_circumference",
      "gender",
      // "diabetes",
      // "race",
      // "hypertension",
      // "smoking",
    ];

    const missingFields = [];

    console.log(missingFields);

    for (let field of requiredFields) {
      if (!profileData[field]?.toString().trim()) {
        missingFields.push(field);
      }
    }

    // if (diabetesYesNo === "") missingFields.push("diabetesYesNo");
    // if (diabetesYesNo === "1" && diabetesType === "")
    //   missingFields.push("diabetesType");

    if (missingFields.length) {
      console.warn("⚠️ Missing Required Fields:", missingFields);
      return false;
    }

    return true;
  };

  const handleGuestScan = () => {
    setFormSubmitted(true);
    // setMsgLoader(true);

    if (!profileData.firstName) {
      window.showToast("error", "Please enter First Name");
      setMsgLoader(false);
      return;
    }

    if (!profileData.lastName) {
      window.showToast("error", "Please enter Last Name");
      setMsgLoader(false);
      return;
    }

    // if (!profileData.dob) {
    //     window.showToast("error", "Please select Date of Birth");
    //     setMsgLoader(false);
    //     return;
    // }

    // const dobDate = new Date(profileData.dob);

    // if (isNaN(dobDate.getTime())) {
    //     window.showToast("error", "Invalid Date of Birth");
    //     setMsgLoader(false);
    //     return;
    // }

    // const today = new Date();

    // const year = dobDate.getFullYear();
    // const month = String(dobDate.getMonth() + 1).padStart(2, "0");
    // const day = String(dobDate.getDate()).padStart(2, "0");
    // formattedDob = `${year}/${month}/${day}`;

    // age = today.getFullYear() - dobDate.getFullYear();
    // const monthDiff = today.getMonth() - dobDate.getMonth();

    // if (
    //     monthDiff < 0 ||
    //     (monthDiff === 0 && today.getDate() < dobDate.getDate())
    // ) {
    //     age--;
    // }

    // if (age < 18) {
    //     window.showToast("error", "User must be at least 18 years old.");
    //     setMsgLoader(false);
    //     return;
    // }

    if (!validateForm()) {
      window.showToast("error", "Please fill all required fields");
      return;
    }

    const finalData = {
      ...profileData,
      // dob: formattedDob,
      guestUserKey: guestData?.guest_user_key,
      scanType: "guest",
      servings: {
        fruits_servings: servingData.fruits,
        vegetables_servings: servingData.vegetables,
        grains_servings: servingData.grains,
        sugaryfoods_servings: servingData.sugaryFoods,
        redmeat_servings: servingData.redMeat,
        fish_servings: servingData.fish,
        activity: servingData.activity,
      },
    };
    storage.set("guestUserKey", guestData?.guest_user_key);

    saveGuestUser(finalData);
  };

  const SKIN_TONES = [
    {
      key: "Very Light",
      v: screenLabels?.skin_tone_very_light?.label_value || "Very Light",
      c: "#F5D5C0",
    },
    {
      key: "Light",
      v: screenLabels?.skin_tone_light?.label_value || "Light",
      c: "#E8B89A",
    },
    {
      key: "Light Medium",
      v: screenLabels?.skin_tone_light_medium?.label_value || "Light Medium",
      c: "#D69875",
    },
    {
      key: "Medium",
      v: screenLabels?.skin_tone_medium?.label_value || "Medium",
      c: "#B97B57",
    },
    {
      key: "Medium Dark",
      v: screenLabels?.skin_tone_medium_dark?.label_value || "Medium Dark",
      c: "#8E5A3D",
    },
    {
      key: "Dark",
      v: screenLabels?.skin_tone_dark?.label_value || "Dark",
      c: "#5F3825",
    },
    {
      key: "Very Dark",
      v: screenLabels?.skin_tone_very_dark?.label_value || "Very Dark",
      c: "#3E2417",
    },
  ];

  return (
    <div className="content-part guest-scan-form mb-2 pb-4">
      {/* <div className="card"></div> */}
      <div className="form-group">
        <h5 className="mt-3 mb-0 text-center">
          <UserRound />
          &nbsp;
          {authLabel?.guest_information?.label_value || "Guest Information"}
        </h5>
        <div className="mt-2">
          <div className="row">
            <div className="col-6">
              <div className="form-group mb-3">
                <label className="fw-semibold">
                  {" "}
                  {renderLabelWithValidation(
                    "firstName",
                    authLabel?.first_name?.label_value || "First Name",
                    true,
                  )}
                </label>

                <input
                  type="text"
                  className={`form-control wrInputText ${formSubmitted && !profileData?.firstName?.trim() ? "is-invalid" : ""}`}
                  value={profileData?.firstName || ""}
                  placeholder={
                    authLabel?.enter_first_name?.label_value ||
                    "Enter first name"
                  }
                  onChange={(e) =>
                    handleInputChange("firstName", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group mb-3">
                <label className="fw-semibold">
                  {renderLabelWithValidation(
                    "lastName",
                    authLabel?.last_name?.label_value || "Last Name",
                    true,
                  )}
                </label>
                <input
                  type="text"
                  className={`form-control wrInputText ${formSubmitted && !profileData?.lastName?.trim() ? "is-invalid" : ""}`}
                  value={profileData?.lastName || ""}
                  placeholder={
                    authLabel?.enter_last_name?.label_value || "Enter last name"
                  }
                  onChange={(e) =>
                    handleInputChange("lastName", e.target.value)
                  }
                />
              </div>
            </div>
          </div>

          {/* <div className="row">
                        <div
                            className="form-group mb-3 position-relative"
                            ref={calendarRef}
                        >
                            <label className="fw-semibold">{renderLabelWithValidation(
                                "dob",
                                `${authLabel?.date_of_birth?.label_value || "Date of birth"} (${authLabel?.min_age_text?.label_value ||
                                "must be at least 18 years old"
                                })`,
                                true
                            )}</label>

                            <div className="position-relative">
                                <div
                                    className={`form-control wrInputText pe-5 ${formSubmitted && !profileData?.dob ? "is-invalid" : ""}`}
                                    onClick={() => setShowCalendar(!showCalendar)}
                                    style={{ cursor: "pointer", backgroundColor: "#fff" }}
                                >
                                    {profileData?.dob
                                        ? new Date(profileData.dob).toLocaleDateString("en-GB")
                                        : "Select date"}
                                </div>

                                <CalendarDays
                                    size={18}
                                    className="position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                                    pointerEvents="none"
                                />
                            </div>

                            {showCalendar && (
                                <div
                                    className="position-absolute bg-white mt-1"
                                    style={{ zIndex: 3 }}
                                >
                                    <Calendar
                                        mode="dob"
                                        value={profileData?.dob}
                                        onDateChange={(dateObj) => {
                                            handleInputChange("dob", dateObj);
                                            setShowCalendar(false);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div> */}
          <div>
            <div className="form-group mb-3">
              <label className="fw-semibold">
                {" "}
                {renderLabelWithValidation(
                  "age",
                  authLabel?.what_is_your_age?.label_value ||
                  "What is your age?",
                  true,
                )}
              </label>
              <input
                type="number"
                placeholder={
                  screenLabels?.enter_your_age?.label_value ||
                  "Enter your age"
                }
                className={`form-control wrInputText ${formSubmitted && !profileData?.age?.toString().trim() ? "is-invalid" : ""}`}
                value={profileData?.age || ""}
                onChange={(e) =>
                  setProfileData((prev) => ({
                    ...prev,
                    age: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          <h5 className="my-2 mt-3 mb-0 text-center">
            <PersonStanding />
            &nbsp;
            {authLabel?.physical_information?.label_value ||
              "Physical Information"}
          </h5>

          <div className="form-group mt-2">
            <label className="fw-semibold">
              {renderLabelWithValidation(
                "gender",
                // authLabel?.gender_at_birth?.label_value || "Gender At Birth",
                authLabel?.fourLife_gender_at_birth?.label_value ||
                "Gender At Birth",
                true,
              )}
            </label>
            <div className="d-flex w-100 gap-3">
              {/* Male */}
              <div
                className={`custom-checkbox custom-selection position-relative w-50 ${profileData.gender === "male" ? "active-selection" : ""}${formSubmitted && !profileData.gender ? " border border-danger" : ""}`}
                onClick={() => handleInputChange("gender", "male")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="input-image">
                      <img src={images.maleImg} alt="male" />
                    </div>
                    <p className="mb-0 fw-semibold">
                      {authLabel?.male?.label_value || "Male"}
                    </p>
                  </div>
                  <input
                    type="radio"
                    id="guestMaleOption"
                    name="guestGender"
                    value="male"
                    checked={profileData.gender === "male"}
                    onChange={() => handleInputChange("gender", "male")}
                    hidden
                  />
                  <label
                    htmlFor="guestMaleOption"
                    className="custom-label-left"
                  ></label>
                </div>
              </div>

              {/* Female */}
              <div
                className={`custom-checkbox custom-selection position-relative w-50 ${profileData.gender === "female" ? "active-selection" : ""}${formSubmitted && !profileData.gender ? " border border-danger" : ""}`}
                onClick={() => handleInputChange("gender", "female")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="input-image">
                      <img src={images.femaleImg} alt="female" />
                    </div>
                    <p className="mb-0 fw-semibold">
                      {authLabel?.female?.label_value || "Female"}
                    </p>
                  </div>
                  <input
                    type="radio"
                    id="guestFemaleOption"
                    name="guestGender"
                    value="female"
                    checked={profileData.gender === "female"}
                    onChange={() => handleInputChange("gender", "female")}
                    hidden
                  />
                  <label
                    htmlFor="guestFemaleOption"
                    className="custom-label-left"
                  ></label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mt-3">
            <label className="fw-semibold mb-2">
              {screenLabels?.camera_selection?.label_value || "Select Camera"}
            </label>
            <div className="d-flex w-100 gap-2">
              {/* Front Camera */}
              <div
                className={`custom-checkbox custom-selection position-relative flex-grow-1 ${profileData.cameraMode === "front" ? "active-selection" : ""}`}
                onClick={() => handleInputChange("cameraMode", "front")}
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex justify-content-between align-items-center p-3">
                  <div className="d-flex align-items-center gap-2">
                    <Smartphone size={22} />
                    <p className="mb-0 fw-semibold">
                      {screenLabels?.front_camera?.label_value || "Front"}
                    </p>
                  </div>
                  <input
                    type="radio"
                    id="guestFrontCamera"
                    name="cameraMode"
                    value="front"
                    checked={profileData.cameraMode === "front"}
                    onChange={() => handleInputChange("cameraMode", "front")}
                    hidden
                  />
                  <label
                    htmlFor="guestFrontCamera"
                    className="custom-label-left mb-0"
                  ></label>
                </div>
              </div>

              {/* Back Camera */}
              <div
                className={`custom-checkbox custom-selection position-relative flex-grow-1 ${profileData.cameraMode === "back" ? "active-selection" : ""}`}
                onClick={() => handleInputChange("cameraMode", "back")}
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex justify-content-between align-items-center p-3">
                  <div className="d-flex align-items-center gap-2">
                    <Camera size={22} />
                    <p className="mb-0 fw-semibold">
                      {screenLabels?.back_camera?.label_value || "Back"}
                    </p>
                  </div>
                  <input
                    type="radio"
                    id="guestBackCamera"
                    name="cameraMode"
                    value="back"
                    checked={profileData.cameraMode === "back"}
                    onChange={() => handleInputChange("cameraMode", "back")}
                    hidden
                  />
                  <label
                    htmlFor="guestBackCamera"
                    className="custom-label-left mb-0"
                  ></label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mt-3">
            <label className="fw-semibold">
              {renderLabelWithValidation(
                "race",
                authLabel?.skin_text?.label_value || "What is your skin tone?",
                false,
              )}
            </label>
            <div className="d-flex flex-wrap gap-2 mt-2">
              {SKIN_TONES.map((tone) => (
                <div
                  key={tone.key}
                  onClick={() => handleInputChange("race", tone.key)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px",
                    borderRadius: "8px",
                    border:
                      profileData?.race === tone.key
                        ? "3px solid #007bff"
                        : "2px solid #ddd",
                    transition: "all 0.2s",
                  }}
                  title={tone.v}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      backgroundColor: tone.c,
                      border: "1px solid rgba(0, 0, 0, 0.12)",
                      boxShadow: "rgba(0, 0, 0, 0.18) 0px 1px 2px inset",
                      marginBottom: "4px",
                    }}
                  />
                  <small
                    style={{
                      fontSize: "11px",
                      textAlign: "center",
                      width: "60px",
                    }}
                  >
                    {tone.v}
                  </small>
                </div>
              ))}
            </div>
          </div>

          <div className="form-group mt-3">
            <label className="fw-semibold">
              {renderLabelWithValidation(
                "weight",
                // authLabel?.weight?.label_value || "Weight",
                authLabel?.fourLife_weight?.label_value || "Weight",
                true,
              )}
            </label>
            <input
              type="text"
              className={`form-control wrInputText ${formSubmitted && !profileData?.weight ? "is-invalid" : ""}`}
              placeholder={
                authLabel?.enter_weight?.label_value || "Enter weight"
              }
              value={
                profileData?.weight && profileData?.weightUnit
                  ? `${profileData.weight}\u00A0\u00A0${profileData.weightUnit}`
                  : ""
              }
              readOnly
              onClick={() => setWeightModal(true)}
            />
          </div>

          <div className="form-group mt-3">
            <label className="fw-semibold">
              {renderLabelWithValidation(
                "height",
                // authLabel?.height?.label_value || "Height",
                authLabel?.fourLife_height?.label_value || "Height",
                true,
              )}
            </label>
            <div className="input-group">
              <input
                type="text"
                className={`form-control wrInputText ${formSubmitted && !profileData?.height ? "is-invalid" : ""}`}
                placeholder={
                  authLabel?.enter_height?.label_value || "Enter height"
                }
                value={
                  `${profileData?.height} ${profileData?.heightUnit} ` || ""
                }
                readOnly
                onClick={() => setShowHeightModal(true)}
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <label className="fw-semibold">
              {renderLabelWithValidation(
                "waist_circumference",
                authLabel?.waist_circumference?.label_value ||
                "Waist Circumference",
                true,
              )}
            </label>
            <div className="input-group">
              <input
                type="text"
                className={`form-control wrInputText ${formSubmitted && !profileData?.waist_circumference ? "is-invalid" : ""}`}
                placeholder={
                  authLabel?.enter_value_in_cm?.label_value ||
                  "Enter value in cm"
                }
                value={
                  profileData?.waist_circumference && profileData?.waistUnit
                    ? `${profileData.waist_circumference}\u00A0\u00A0${profileData.waistUnit}`
                    : ""
                }
                readOnly
                onClick={() => setShowWaistModal(true)}
              />
            </div>
          </div>

          <h5 className="mt-4 mb-3 text-center">
            <Stethoscope />
            &nbsp;
            {authLabel?.wellness_information?.label_value ||
              "Wellness Information"}
          </h5>

          <div className="form-group mt-3">
            <label className="fw-semibold">
              {authLabel?.blood_sugar?.label_value ||
                "Are you managing blood sugar levels?"}
            </label>
            <div className="d-flex w-100 gap-3 mt-1 flex-wrap">
              {[
                {
                  label: authLabel?.yes?.label_value || "Yes",
                  code: "1",
                  diabetesVal: "Yes",
                },
                {
                  label: authLabel?.no?.label_value || "No",
                  code: "2",
                  diabetesVal: "No",
                },
                {
                  label:
                    authLabel?.prefer_not_to_say?.label_value ||
                    "Prefer not to say",
                  code: "3",
                  diabetesVal: "Not say",
                },
              ].map(({ label, code, diabetesVal }) => (
                <div
                  key={code}
                  className={`custom-checkbox custom-selection position-relative flex-grow-1 ${diabetesYesNo === code ? "active-selection" : ""}`}
                  onClick={() => {
                    setDiabetesYesNo(code);
                    setDiabetesType("");
                    handleInputChange("diabetes", diabetesVal);
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="m-0 fw-semibold">{label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="form-group mt-3">
            <label className="fw-semibold">
              {renderLabelWithValidation(
                "smoking",
                authLabel?.tobacco_or_nicotine?.label_value ||
                "Do you currently use tobacco or nicotine products?",
                true,
              )}
            </label>
            <div className="d-flex w-100 gap-3 mt-1 flex-wrap">
              {[
                { label: authLabel?.yes?.label_value || "Yes", value: "Yes" },
                { label: authLabel?.no?.label_value || "No", value: "No" },
                {
                  label:
                    authLabel?.prefer_not_to_say?.label_value ||
                    "Prefer not to say",
                  value: "Not say",
                },
              ].map(({ label, value }) => (
                <div
                  key={value}
                  className={`custom-checkbox custom-selection position-relative flex-grow-1 ${profileData?.smoking === value ? "active-selection" : ""}${formSubmitted && !profileData.smoking ? " border border-danger" : ""}`}
                  onClick={() => handleInputChange("smoking", value)}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="m-0 fw-semibold">{label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {is4Life && (
            <div className="mt-4 mb-2">
              <h5 className="mb-3 d-flex align-items-center gap-2 text-center justify-content-center">
                <Activity size={18} />
                {authLabel?.lifestyle_details?.label_value || "Lifestyle Details"}
              </h5>

              {nutritionQuestions.map((q) => (
                <div className="mb-3" key={q.key}>
                  <div className="d-flex align-items-center gap-2">
                    <div className="input-image">
                      <img src={q.icon} alt="icon" />
                    </div>
                    <label
                      className="form-label question-label mb-0"
                      style={{ fontSize: "13px" }}
                    >
                      {q.label}
                    </label>
                  </div>
                  <select
                    className="form-select mt-1"
                    value={servingData[q.key] || ""}
                    onChange={(e) => handleServingChange(q.key, e.target.value)}
                  >
                    <option value="" disabled>
                      {screenLabels?.select_option?.label_value || "Select Option"}
                    </option>
                    {servingOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ))}

              <h5 className="mt-3 mb-3 d-flex align-items-center gap-2 text-center justify-content-center">
                <Activity size={18} />
                {screenLabels?.weekly_activity?.label_value || "Weekly Activity"}
              </h5>

              <div className="mb-3">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div className="input-image">
                    <img src={images.activity} alt="activity" />
                  </div>
                  <label
                    className="form-label question-label mb-0"
                    style={{ fontSize: "13px" }}
                  >
                    {screenLabels?.activity?.label_value ||
                      "How many minutes of moderate or vigorous physical activity do you get each week?(Moderate: breathing harder, can talk in short sentences. Vigorous: heavy breathing, few words at a time.)"}
                  </label>
                </div>
                <select
                  className="form-select mt-1"
                  value={servingData.activity || ""}
                  onChange={(e) => handleServingChange("activity", e.target.value)}
                >
                  <option value="" disabled>
                    {screenLabels?.select_option?.label_value || "Select Option"}
                  </option>
                  {["Less than 50", "51 - 100", "101 - 150", "More than 150"].map(
                    (opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ),
                  )}
                </select>
              </div>
            </div>
          )}

          {/* <div className="row">
            <div className="col-12 mt-3">
              <div className="form-group">
                <label className="fw-semibold">
                  {renderLabelWithValidation(
                    "race",
                    authLabel?.race?.label_value || "Race",
                    true,
                  )}
                </label>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-image">
                    <img src={images.race} alt="race" />
                  </div>
                  <select
                    className={`form-select ${formSubmitted && !profileData?.race ? "is-invalid" : ""}`}
                    value={profileData?.race || ""}
                    onChange={(e) => handleInputChange("race", e.target.value)}
                  >
                    <option value="" disabled>
                      {authLabel?.select_race?.label_value || "Select Race"}
                    </option>
                    <option value="White">
                      {authLabel?.white?.label_value || "White"}
                    </option>
                    <option value="Black">
                      {authLabel?.black?.label_value || "Black"}
                    </option>
                    <option value="Asian">
                      {authLabel?.asian?.label_value || "Asian"}
                    </option>
                    <option value="Other">
                      {authLabel?.other?.label_value || "Other"}
                    </option>
                    <option value="Prefer Not To Answer">
                      {authLabel?.prefer_not_to_answer?.label_value ||
                        "Prefer Not To Answer"}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* <h5 className="mt-3 mb-0 text-center">
        <Stethoscope />
        &nbsp;
        {authLabel?.medical_information?.label_value || "Medical Information"}
      </h5>

      <div className="row">
        <div className="col-md-6 my-3">
          <div className="form-group">
            <label className="fw-semibold">
              {renderLabelWithValidation(
                "diabetes",
                authLabel?.diabetes?.label_value || "Diabetes",
                true,
              )}
            </label>
            <div className="d-flex align-items-center gap-2">
              <div className="input-image">
                <img src={images.diabetic} alt="diabetes" />
              </div>
              <select
                className={`form-select ${formSubmitted && !diabetesYesNo ? "is-invalid" : ""}`}
                value={diabetesYesNo || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setDiabetesYesNo(value);
                  if (value === "2") {
                    setDiabetesType("");
                    handleInputChange("diabetes", "No");
                  } else if (value === "1") {
                    setDiabetesType("");
                    handleInputChange("diabetes", "");
                  } else {
                    setDiabetesType("");
                    handleInputChange("diabetes", "");
                  }
                }}
              >
                <option value="" disabled>
                  {authLabel?.select_option?.label_value || "Select Option"}
                </option>
                <option value="1">
                  {authLabel?.yes?.label_value || "Yes"}
                </option>
                <option value="2">{authLabel?.no?.label_value || "No"}</option>
              </select>
            </div>
          </div>

          {diabetesYesNo === "1" && (
            <div className="mt-3">
              <label className="form-label mb-1">
                {authLabel?.diabetes_type?.label_value || "Diabetes Type"}:
              </label>
              <div
                className={`d-flex gap-4 align-items-center mt-1 p-2 rounded ${formSubmitted && diabetesYesNo === "1" && !diabetesType ? "border border-danger" : ""}`}
              >
                <div className="custom-checkbox form-check p-0">
                  <input
                    type="radio"
                    id="type1"
                    value="Type 1"
                    name="diabetesType"
                    checked={diabetesType === "Type 1"}
                    onChange={(e) => {
                      const val = e.target.value;
                      setDiabetesType(val);
                      handleInputChange("diabetes", val);
                    }}
                  />
                  <label
                    className="custom-label fw-semibold mb-0"
                    htmlFor="type1"
                  >
                    {authLabel?.type_1?.label_value || "Type 1"}
                  </label>
                </div>
                <div className="custom-checkbox form-check p-0">
                  <input
                    type="radio"
                    id="type2"
                    value="Type 2"
                    name="diabetesType"
                    checked={diabetesType === "Type 2"}
                    onChange={(e) => {
                      const val = e.target.value;
                      setDiabetesType(val);
                      handleInputChange("diabetes", val);
                    }}
                  />
                  <label
                    className="custom-label fw-semibold mb-0"
                    htmlFor="type2"
                  >
                    {authLabel?.type_2?.label_value || "Type 2"}
                  </label>
                </div>
                <div className="custom-checkbox form-check p-0">
                  <input
                    type="radio"
                    id="notSure"
                    value="Not Sure"
                    name="diabetesType"
                    checked={diabetesType === "Not Sure"}
                    onChange={(e) => {
                      const val = e.target.value;
                      setDiabetesType(val);
                      handleInputChange("diabetes", val);
                    }}
                  />
                  <label
                    className="custom-label fw-semibold mb-0"
                    htmlFor="notSure"
                  >
                    {authLabel?.not_sure?.label_value || "Not Sure"}
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label className="fw-semibold">
              {renderLabelWithValidation(
                "hypertension",
                authLabel?.hypertension?.label_value || "Hypertension",
                true,
              )}
            </label>
            <div className="d-flex align-items-center gap-2">
              <div className="input-image">
                <img src={images.bloodPressure} alt="hypertension" />
              </div>
              <select
                className={`form-select ${formSubmitted && !profileData?.hypertension ? "is-invalid" : ""}`}
                value={profileData?.hypertension || ""}
                onChange={(e) =>
                  handleInputChange("hypertension", e.target.value)
                }
              >
                <option value="" disabled>
                  {authLabel?.select_option?.label_value || "Select Option"}
                </option>
                <option value="Yes">
                  {authLabel?.yes?.label_value || "Yes"}
                </option>
                <option value="No">{authLabel?.no?.label_value || "No"}</option>
              </select>
            </div>
          </div>
        </div>
        <div className="form-group mt-3 mb-4">
          <label className="fw-semibold">
            {renderLabelWithValidation(
              "smoking",
              authLabel?.smoking?.label_value || "Smoking",
              true,
            )}
          </label>
          <div className="d-flex align-items-center gap-2 mt-1">
            <div className="input-image">
              <img src={images.smoke} alt="smoke" className="mb-2" />
            </div>
            <div className="d-flex w-100 gap-3">
              <div
                className={`custom-checkbox custom-selection position-relative flex-grow-1 ${profileData?.smoking === "Yes" ? "active-selection" : ""}${formSubmitted && !profileData.smoking ? " border border-danger" : ""}`}
                onClick={() => handleInputChange("smoking", "Yes")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <p className="m-0 fw-semibold">
                    {authLabel?.yes?.label_value || "Yes"}
                  </p>
                  <div>
                    <input
                      type="radio"
                      id="guestSmokeYesOption"
                      name="guestSmoking"
                      value="Yes"
                      checked={profileData?.smoking === "Yes"}
                      onChange={() => handleInputChange("smoking", "Yes")}
                      className="d-none"
                    />
                    <label
                      className="custom-label-left w-100 mb-0"
                      htmlFor="guestSmokeYesOption"
                    ></label>
                  </div>
                </div>
              </div>

              <div
                className={`custom-checkbox custom-selection position-relative flex-grow-1 ${profileData?.smoking === "No" ? "active-selection" : ""}${formSubmitted && !profileData.smoking ? " border border-danger" : ""}`}
                onClick={() => handleInputChange("smoking", "No")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <p className="m-0 fw-semibold">
                    {authLabel?.no?.label_value || "No"}
                  </p>
                  <div>
                    <input
                      type="radio"
                      id="guestSmokeNoOption"
                      name="guestSmoking"
                      value="No"
                      checked={profileData?.smoking === "No"}
                      onChange={() => handleInputChange("smoking", "No")}
                      className="d-none"
                    />
                    <label
                      className="custom-label-left w-100 mb-0"
                      htmlFor="guestSmokeNoOption"
                    ></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="my-3 ">
        <h6>{screenLabels?.disclaimer?.label_value || "Disclaimer"}</h6>
        <p className="fs-15px">
          {is4Life
            ? screenLabels?.fourLife_disclaimer_content?.label_value
            : screenLabels?.disclaimer_content?.label_value ||
            "The metrics provided by GlobalHealth AI are wellness estimates and are intended for informational and general health awareness purposes only. This app is not a medical device and does not diagnose, monitor, or treat medical conditions. Please consult a qualified healthcare professional for medical advice."}
        </p>
      </div>
      <div className="pb-5">
        <h6>
          {screenLabels?.scan_guidelines?.label_value || "Scan Guidelines"}
        </h6>
        <ul className="m-0 ps-3">
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline1?.label_value ||
              "Keep your face evenly illuminated."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline2?.label_value ||
              "Use a single light source directed at your face."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline3?.label_value ||
              "Sit where no light falls directly on the camera."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline4?.label_value ||
              "Ensure the camera area isn’t exposed to sunlight."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline5?.label_value ||
              "Avoid movement of people in the background."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline6?.label_value ||
              "Remove reflective items like mirrors, glass, or shiny tables."}
          </li>
        </ul>
      </div>

      {scanLimit === true ? (
        <div className="text-center start-scan-button" style={{ zIndex: 2 }}>
          <button className="btn btn-primary" onClick={handleGuestScan}>
            {screenLabels?.start_guest_scan?.label_value || "Start Guest Scan"}
          </button>
        </div>
      ) : (
        <>
          <div className="text-center start-scan-button w-100 p-3">
            <Alert variant="danger" className="p-1 m-0 bg-danger">
              <p className="m-0 text-white">
                You’ve hit your monthly scan limit.
              </p>
            </Alert>
          </div>
        </>
      )}

      <WeightModal
        show={showWeightModal}
        onClose={() => setWeightModal(false)}
        initialWeight={profileData.weight}
        initialUnit={profileData.weightUnit}
        onSave={({ weight, weightUnit }) => {
          if (weightUnit === "kg") {
            if (weight < 20 || weight > 300) {
              window.showToast("error", "Weight must be between 20–300 kg.");
              return;
            }
          } else if (weightUnit === "lbs") {
            if (weight < 44 || weight > 661) {
              window.showToast("error", "Weight must be between 44–661 lbs.");
              return;
            }
          }
          setProfileData((prev) => ({
            ...prev,
            weight,
            weightUnit,
          }));
          setWeightModal(false);
        }}
      />

      <HeightModal
        show={showHeightModal}
        onClose={() => setShowHeightModal(false)}
        initialHeight={profileData.height}
        initialUnit={profileData.heightUnit}
        onSave={({ height, heightUnit }) => {
          if (heightUnit === "cm") {
            if (height < 100 || height > 250) {
              window.showToast("error", "Height must be between 100–250 cm.");
              return;
            }
          } else if (heightUnit === "feet") {
            if (height < 3.3 || height > 8.2) {
              window.showToast("error", "Height must be between 3.3–8.2 feet.");
              return;
            }
          }
          setProfileData((prev) => ({
            ...prev,
            height,
            heightUnit,
          }));
          setShowHeightModal(false);
        }}
      />

      <WaistModal
        show={showWaistModal}
        onClose={() => setShowWaistModal(false)}
        initialWaist={profileData.waist_circumference}
        initialUnit={profileData.waistUnit}
        onSave={({ waist_circumference, waistUnit }) => {
          setProfileData((prev) => ({
            ...prev,
            waist_circumference,
            waistUnit,
          }));
          setShowWaistModal(false);
        }}
      />
    </div>
  );
};

export default GuestScan;
